import { ESimulationKey } from "../types/entities.enum";

export const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const getSimulationColor = (simulationKey: ESimulationKey | null): string => {
    if (simulationKey === ESimulationKey.TRUSTED_CUSTOMERS || simulationKey === ESimulationKey.EXTRA_DRAWER_KEYS || simulationKey === ESimulationKey.VETERAN_BRANCH_MANAGER) {
        return '#4A306D';
    };

    if (simulationKey === ESimulationKey.THE_SLOGAN_BACKLASH) {
        return '#10B981';
    };

    if (simulationKey === ESimulationKey.ROCKSTAR_REALITY_CHECK) {
        return '#F59E0B';
    };

    return '#3B82F6';
};

export const getInteractionLimits = (simulationKey: ESimulationKey | null): { eligibility: number; level1: number; level2: number } => {
    if (simulationKey === ESimulationKey.TRUSTED_CUSTOMERS || simulationKey === ESimulationKey.EXTRA_DRAWER_KEYS || simulationKey === ESimulationKey.VETERAN_BRANCH_MANAGER) {
        return { eligibility: 5, level1: 7, level2: 15 };
    };

    if (simulationKey === ESimulationKey.THE_SLOGAN_BACKLASH) {
        return { eligibility: 5, level1: 8, level2: 15 };
    };

    if (simulationKey === ESimulationKey.ROCKSTAR_REALITY_CHECK) {
        return { eligibility: 5, level1: 10, level2: 20 };
    };

    return { eligibility: 5, level1: 6, level2: 15 };
};

export const getScoreColor = (score: number): 'red' | 'yellow' | 'green' => {
    if (score < 3) return 'red';
    if (score < 5) return 'yellow';
    return 'green';
};